
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTiktokApp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 32,
  viewBox: "0 0 30 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#tiktok-app_38c8fa4ec56edd81__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.259 11.474v-.96a7.273 7.273 0 0 0-.983-.07C7.264 10.444 4 13.706 4 17.72a7.271 7.271 0 0 0 3.105 5.958 7.23 7.23 0 0 1-1.93-4.955 7.243 7.243 0 0 1 7.084-7.25Z",
  fill: "#25F4EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.428 22.07c1.79 0 3.276-1.447 3.341-3.222l.005-15.82 2.87-.025A5.519 5.519 0 0 1 18.55 2H14.6l-.007 15.844a3.316 3.316 0 0 1-4.859 2.82c.604.835 1.585 1.406 2.694 1.406ZM24.054 8.408v-.907a5.47 5.47 0 0 1-2.995-.89c.768.881 1.812 1.544 2.995 1.797Z",
  fill: "#25F4EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.058 6.61a5.478 5.478 0 0 1-1.352-3.606h-1.061a5.512 5.512 0 0 0 2.413 3.606ZM11.275 14.396a3.321 3.321 0 0 0-1.54 6.267 3.317 3.317 0 0 1 3.674-5.11v-4.036a7.264 7.264 0 0 0-.981-.07c-.057 0-.114.002-.172.004v3.099a3.273 3.273 0 0 0-.98-.154Z",
  fill: "#FE2C55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.052 8.382v3.072a9.401 9.401 0 0 1-5.5-1.768v8.034c0 4.012-3.264 7.277-7.277 7.277a7.234 7.234 0 0 1-4.17-1.32A7.256 7.256 0 0 0 12.428 26c4.012 0 7.277-3.262 7.277-7.277V10.69a9.405 9.405 0 0 0 5.5 1.769V8.504c-.387 0-.774-.041-1.152-.122Z",
  fill: "#FE2C55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.552 17.72V9.685a9.402 9.402 0 0 0 5.5 1.77V8.381a5.502 5.502 0 0 1-2.995-1.772 5.512 5.512 0 0 1-2.412-3.606h-2.894l-.006 15.844a3.316 3.316 0 0 1-6.011 1.815 3.322 3.322 0 0 1 1.54-6.267c.334.001.665.053.983.154v-3.1c-3.933.093-7.105 3.318-7.105 7.272a7.25 7.25 0 0 0 1.953 4.956 7.235 7.235 0 0 0 4.17 1.319c4.012 0 7.277-3.265 7.277-7.277Z",
  fill: "#000"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "tiktok-app_38c8fa4ec56edd81__a",
  x: -1.5,
  y: 0,
  width: 32,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9466_1623"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9466_1623",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"30\" height=\"32\" viewBox=\"0 0 30 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g filter=\"url(#filter0_d_9466_1623)\">\r\n<path d=\"M12.2587 11.4737V10.5139C11.9332 10.4685 11.6049 10.4453 11.2762 10.4443C7.26412 10.4443 4 13.7065 4 17.7197C4.0002 18.8893 4.28254 20.0416 4.82307 21.0788C5.3636 22.116 6.14637 23.0075 7.10494 23.6777C5.89401 22.3775 5.17477 20.6356 5.17477 18.7231C5.17256 16.8283 5.91303 15.008 7.23734 13.6528C8.56166 12.2975 10.3643 11.5152 12.2587 11.4737Z\" fill=\"#25F4EE\"/>\r\n<path d=\"M12.4282 22.0705C14.2185 22.0705 15.7041 20.6226 15.769 18.8476L15.7745 3.02777L18.6436 3.00341C18.582 2.67248 18.5508 2.33661 18.5504 2H14.5993L14.593 17.8442C14.5736 18.4053 14.4121 18.9523 14.1236 19.4338C13.8351 19.9154 13.429 20.3158 12.9434 20.5976C12.4578 20.8794 11.9087 21.0332 11.3474 21.0447C10.7861 21.0562 10.2311 20.925 9.73438 20.6634C10.3385 21.4986 11.3195 22.0705 12.4282 22.0705Z\" fill=\"#25F4EE\"/>\r\n<path d=\"M24.0539 8.40807V7.50096C22.9901 7.50165 21.9492 7.19215 21.0586 6.61035C21.8266 7.49231 22.8709 8.15457 24.0539 8.40807Z\" fill=\"#25F4EE\"/>\r\n<path d=\"M21.0581 6.61035C20.1856 5.61156 19.7051 4.33014 19.7057 3.00391H18.6445C18.7819 3.73707 19.0666 4.43473 19.4815 5.05464C19.8964 5.67454 20.4327 6.2038 21.0581 6.61035Z\" fill=\"#FE2C55\"/>\r\n<path d=\"M11.2753 14.3964C10.5315 14.3954 9.809 14.6441 9.22338 15.1026C8.63775 15.5611 8.22292 16.2028 8.04532 16.925C7.86772 17.6472 7.93763 18.4082 8.24384 19.086C8.55005 19.7637 9.07486 20.3191 9.73421 20.6632C9.37581 20.1676 9.16141 19.5825 9.11471 18.9726C9.068 18.3628 9.19081 17.7518 9.46957 17.2074C9.74832 16.6629 10.1722 16.2062 10.6943 15.8875C11.2164 15.5689 11.8164 15.4007 12.428 15.4017C12.7608 15.4021 13.0915 15.4534 13.4087 15.5538V11.5174C13.0838 11.4716 12.7561 11.4478 12.428 11.4463C12.3707 11.4463 12.3137 11.4494 12.2563 11.4506V14.55C11.939 14.4492 11.6082 14.3974 11.2753 14.3964Z\" fill=\"#FE2C55\"/>\r\n<path d=\"M24.0525 8.38184V11.4545C22.079 11.4569 20.1548 10.8381 18.5525 9.68591V17.7198C18.5525 21.7323 15.288 24.9968 11.2755 24.9968C9.78271 24.9979 8.32611 24.5372 7.10547 23.6778C7.78494 24.4104 8.6084 24.9949 9.52427 25.3944C10.4401 25.794 11.4287 26.0001 12.4279 25.9998C16.4403 25.9998 19.7048 22.7377 19.7048 18.7232V10.6889C21.3072 11.841 23.2314 12.4597 25.2049 12.4576V8.50407C24.8176 8.50391 24.4313 8.46294 24.0525 8.38184Z\" fill=\"#FE2C55\"/>\r\n<path d=\"M18.5519 17.7197V9.68542C20.1542 10.8376 22.0784 11.4564 24.052 11.4541V8.38174C22.8882 8.13085 21.8372 7.5093 21.0567 6.61035C20.4317 6.2036 19.8957 5.67426 19.4812 5.05437C19.0666 4.43447 18.7822 3.73691 18.6451 3.00391H15.7508L15.7445 18.8481C15.7202 19.5401 15.4799 20.207 15.0574 20.7555C14.6349 21.3041 14.0513 21.7066 13.3885 21.9067C12.7257 22.1069 12.0169 22.0946 11.3614 21.8715C10.706 21.6485 10.1367 21.226 9.73351 20.6631C9.07415 20.319 8.54935 19.7636 8.24313 19.0859C7.93692 18.4081 7.86702 17.6471 8.04462 16.9249C8.22222 16.2027 8.63705 15.561 9.22267 15.1025C9.8083 14.644 10.5308 14.3953 11.2746 14.3963C11.608 14.3972 11.9394 14.449 12.2572 14.55V11.4505C8.3241 11.5425 5.15235 14.7681 5.15235 18.7216C5.15067 20.5615 5.8487 22.3333 7.10492 23.6777C8.32545 24.537 9.7819 24.9977 11.2746 24.9967C15.2874 24.9967 18.5519 21.7322 18.5519 17.7197Z\" fill=\"black\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_9466_1623\" x=\"-1.5\" y=\"0\" width=\"32\" height=\"32\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"2\"/>\r\n<feGaussianBlur stdDeviation=\"2\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_9466_1623\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_9466_1623\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/tiktok-app.38c8fa4ec56edd8120146403726de719.svg"),
        {
          React: SvgTiktokApp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      